import {useEffect} from 'react';
import {useRecoilState} from 'recoil';
import {loadingState} from '../atoms';

const useSetLoadingState = (isLoading: boolean) => {
  const [,setLoading] = useRecoilState(loadingState);

  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading, setLoading]);
}

export default useSetLoadingState
